import React, {useState, useEffect} from 'react'
import {
  autoUpdate,
  flip,
  FloatingPortal,
  offset,
  shift,
  useDismiss,
  useFloating,
  useInteractions,
} from '@floating-ui/react'
import Select from 'react-select'
import {shouldDisplayFonctionnalite} from '../../../../components/helpers'

const FavorisModifPrixPopper = (props) => {
  const {
    openFavorisModif,
    setOpenFavorisModif,
    favoriModifLoader,
    favorisDeleteLoader,
    favoriUpdateLoader,
    filters,
    favoriModifPrix,
    handleFavorisModifPrixCreation,
    handleModifPrixFavoriDelete,
    handleModifPrixFavoriUpdate,
    filterTitle,
    applyFavoris,
    setFilterTitle,
    onEdit,
    setOnEdit,
    setShareWithTeam,
    shareWithTeam,
    equipes,
    addTeamOnFavori,
    currentUser,
    allowedToManageFavori,
    setSelectedEquipes
  } = props
  const [favoriInfo, setFavoriInfo] = useState<{
    id: number | null,
    title: string,
    filterData: any
  }>({
    id: null,
    title: '',
    filterData: null
  })
  // --- Popper "Favoris" ---
  const {
    refs: favorisRefs,
    floatingStyles: favorisFloatingStyles,
    context: favorisContext,
  } = useFloating({
    open: openFavorisModif,
    onOpenChange: setOpenFavorisModif,
    placement: 'bottom-start',
    middleware: [offset(6), flip(), shift()],
    whileElementsMounted: (reference, floating, update) =>
      autoUpdate(reference, floating, update, {
        animationFrame: true,
      }),
  })
  const favorisDismiss = useDismiss(favorisContext, {
    outsidePressEvent: 'mousedown',
  })
  const {getReferenceProps: getFavorisReferenceProps, getFloatingProps: getFavorisFloatingProps} =
    useInteractions([favorisDismiss])

  const handleFavorisModifOpening = () => {
    setOpenFavorisModif((prev) => !prev)
  }

  const handleFavoriOnEdit = (fav) => {
    setFilterTitle(fav?.libelle)
    setOnEdit(true)
    setShareWithTeam(fav?.filterData?.equipe?.length > 0)
    setFavoriInfo({
      id: fav?.id,
      title: fav?.libelle,
      filterData: fav?.filterData,
    })
    setSelectedEquipes(fav?.filterData?.equipe)
  }

  return (
    <>
      <div className={'col-1 px-0'}>
        <button
          className={'btn btn-light-warning flex-fill py-4 flex-fill'}
          ref={favorisRefs.setReference}
          {...getFavorisReferenceProps()}
          onClick={handleFavorisModifOpening}
        >
          <div className={'d-flex align-items-center gap-2'}>
            <i className='ki-outline ki-star fs-2'></i>
            <label className={'fs-6'}>Favoris</label>
            {favoriModifLoader ? (
              <span className='spinner-border spinner-border-sm align-middle w-13px h-13px'></span>
            ) : (
              <i className={`fs-2 ki-outline ki-${openFavorisModif ? 'up' : 'down'}`}></i>
            )}
          </div>
        </button>
      </div>
      {openFavorisModif && (
        <FloatingPortal>
          <div
            className='p-6 shadow bg-white p-2 rounded  w-300px'
            ref={favorisRefs.setFloating}
            style={{...favorisFloatingStyles, zIndex: '9999'}}
            {...getFavorisFloatingProps()}
          >
            {favoriModifPrix?.length > 0 ? (
              <>
                <p className={'text-small fw-semibold'}>Favori de l'equipe</p>
                {favoriModifPrix
                  // Favori en fonction de l'equipe du currentUser
                  ?.filter((fav) => {
                    const userEquipeIds = Array.isArray(equipes) ? equipes.map((e: any) => e?.value) : []
                    return (
                      fav?.filterData?.equipe?.length > 0 &&
                      fav.filterData.equipe.some((equipeId: number) => userEquipeIds.includes(equipeId))
                    )
                  })
                  .map((fav) => {
                    return (
                      <>
                        <div
                          className={
                            'form-check form-check-custom form-check-solid form-check-sm justify-content-between p-2 bg-hover-light-primary rounded-1'
                          }
                          key={fav?.id}
                        >
                          <div className={'d-flex'}>
                            <input
                              className='form-check-input me-2'
                              type='radio'
                              id={`option-${fav?.id}`}
                              name={'opt-fav'}
                              checked={!!fav?.actif}
                              onClick={() => applyFavoris(fav)}
                              onChange={() => {}}
                            />
                            <label className='form-check-label' htmlFor={`option-${fav?.id}`}>
                              {fav?.libelle}
                            </label>
                          </div>

                          <div className={'d-flex gap-2'}>
                            {allowedToManageFavori && (
                              <>
                                <i
                                  className={`ki-duotone ki-pencil fs-2 cursor-pointer ${
                                    fav?.id ? 'text-hover-info' : ''
                                  }`}
                                  onClick={() => handleFavoriOnEdit(fav)}
                                >
                                  <span className='path1' />
                                  <span className='path2' />
                                </i>
                                {favorisDeleteLoader[fav?.id] ? (
                                  <span className='spinner-border spinner-border-sm align-middle w-13px h-13px'></span>
                                ) : (
                                  <i
                                    className='ki-duotone ki-trash fs-2 cursor-pointer text-danger'
                                    onClick={() => handleModifPrixFavoriDelete(fav?.id, fav?.actif)}
                                  >
                                    <span className='path1'></span>
                                    <span className='path2'></span>
                                    <span className='path3'></span>
                                    <span className='path4'></span>
                                    <span className='path5'></span>
                                  </i>
                                )}
                              </>
                            )}
                          </div>
                        </div>
                      </>
                    )
                  })}
                <hr className={'flex-grow-1 text-muted w-100 my-1'} />
                <p className={'text-small fw-semibold'}>Favori personnalisé</p>

                {favoriModifPrix
                  ?.filter((fav) => fav?.filterData?.equipe?.length === 0)
                  .map((fav) => {
                    return (
                      <>
                        <div
                          className={
                            'form-check form-check-custom form-check-solid form-check-sm justify-content-between p-2 bg-hover-light-primary rounded-1'
                          }
                          key={fav?.id}
                        >
                          <div className={'d-flex'}>
                            <input
                              className='form-check-input me-2'
                              type='radio'
                              id={`option-${fav?.id}`}
                              name={'opt-fav'}
                              checked={!!fav?.actif}
                              onClick={() => applyFavoris(fav)}
                              onChange={() => {}}
                            />
                            <label className='form-check-label' htmlFor={`option-${fav?.id}`}>
                              {fav?.libelle}
                            </label>
                          </div>

                          <div className={'d-flex gap-2'}>
                            <i
                              className={`ki-duotone ki-pencil fs-2 cursor-pointer ${fav?.id ? 'text-hover-info' : ''}`}
                              onClick={() => handleFavoriOnEdit(fav)}
                              title='Modifier'
                            >
                              <span className='path1' />
                              <span className='path2' />
                            </i>
                            {favorisDeleteLoader[fav?.id] ? (
                              <span className='spinner-border spinner-border-sm align-middle w-13px h-13px'></span>
                            ) : (
                              <i
                                className='ki-duotone ki-trash fs-2 cursor-pointer text-danger'
                                onClick={() => handleModifPrixFavoriDelete(fav?.id, fav?.actif)}
                                title='Supprimer'
                              >
                                <span className='path1'></span>
                                <span className='path2'></span>
                                <span className='path3'></span>
                                <span className='path4'></span>
                                <span className='path5'></span>
                              </i>
                            )}
                          </div>
                        </div>
                      </>
                    )
                  })}
              </>
            ) : (
              <span className={'text-muted text-center d-block w-100'}>
                {favoriModifLoader ? 'Chargement en cours...' : '(Aucun Favori créé)'}
              </span>
            )}

            {!favoriModifLoader && (
              <>
                <hr className={'flex-grow-1 text-muted w-100 my-3'} />
                {
                  // Limiter la création à 10 favoris Max
                  (favoriModifPrix?.length < 10 || onEdit) && (
                    <form
                      onSubmit={(e) => {
                        e.preventDefault()
                        if (onEdit) {
                          handleModifPrixFavoriUpdate(favoriInfo?.id, filters, filterTitle)
                        } else {
                          handleFavorisModifPrixCreation()
                        }
                      }}
                    >
                      <input
                        type='text'
                        className='form-control mb-3'
                        required={true}
                        value={filterTitle}
                        onChange={(e) => setFilterTitle(e.target.value)}
                        placeholder={'Nom du favori'}
                      />

                      {/*Marquer comme libelle pré-etablie*/}
                      {allowedToManageFavori && (
                        <>
                          <div className='form-check form-check-custom form-check-solid form-check-sm mb-3'>
                            <input
                              className='form-check-input'
                              type='checkbox'
                              checked={shareWithTeam}
                              id='flexRadioLg'
                              onChange={() => setShareWithTeam(!shareWithTeam)}
                            />
                            <label className='form-check-label' htmlFor='flexRadioLg'>
                              Partager avec l'équipe
                            </label>
                          </div>
                          {shareWithTeam && (
                            <Select
                              className='react-select-styled react-select-solid react-select-lg flex-fill mb-3'
                              classNamePrefix='react-select'
                              options={equipes}
                              fieldName='equipe'
                              value={equipes?.filter((equipe) =>
                                filters?.equipe?.includes(equipe?.value)
                              )}
                              onChange={(selectedOptions) =>
                                addTeamOnFavori(
                                  selectedOptions ? selectedOptions.map((opt) => opt.value) : []
                                )
                              }
                              menuPortalTarget={document.body}
                              menuPosition='fixed'
                              styles={{
                                menuPortal: (base) => ({...base, zIndex: 9999}),
                                container: (base) => ({...base, width: '250px'}),
                              }}
                              placeholder={'Séléctionner equipe'}
                              isMulti
                              required={shareWithTeam}
                            />
                          )}
                        </>
                      )}
                      <div className={'d-flex justify-content-between w-100'}>
                        <div
                          className={`${onEdit ? 'btn-group btn-group-sm' : ''}`}
                          role='group'
                          aria-label='First group'
                        >
                          <button type='submit' className='btn btn-sm btn-primary'>
                            {onEdit ? 'Modifier' : 'Ajouter'}
                          </button>
                          {onEdit && (
                            <button
                              className={'btn btn-sm btn-light-info'}
                              onClick={() => setOnEdit(false)}
                              type={'submit'}
                            >
                              Annuler
                            </button>
                          )}
                        </div>
                        <button
                          type='button'
                          className='btn btn-sm btn-secondary'
                          onClick={() => setOpenFavorisModif(false)}
                        >
                          Fermer
                        </button>
                      </div>
                    </form>
                  )
                }
              </>
              )
            }
          </div>
        </FloatingPortal>
      )}
    </>
  )
}

export default FavorisModifPrixPopper